import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DATA_ACCESS_ORDER_FEATURE_KEY, reducers } from './reducers';
import { OrderStoreEffects } from './effects';

@NgModule({
  imports: [
    StoreModule.forFeature(DATA_ACCESS_ORDER_FEATURE_KEY, reducers),
    EffectsModule.forFeature([OrderStoreEffects]),
  ],
})
export class OrderStoreModule {}
